import { baseUrl } from "api/baseQuery";
import { getAuthHeaders } from "utils/authHeaders";

/**
 * Reports an empty-data or API failure event to the Django backend.
 * Django will then send an SNMP trap.
 *
 * @param {Object} params
 * @param {string} params.page  - Name of the page/view (e.g. "NOC Infrastructure")
 * @param {string} params.detail - Short description of what was empty/failed
 */
export async function reportError({ page, detail }) {
  try {
    const headers = await getAuthHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    });

    await fetch(`${baseUrl}/reportError/`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        page,
        detail,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch (err) {
    // Never crash the UI if the report itself fails
    console.error("[reportError] Failed to send error report:", err);
  }
}
